module.exports = __webpack_public_path__ + "media/images/pdf/box-6b110e385782ec91ff1501309257a182.png";